module.exports = __webpack_public_path__ + "static/media/gear.e55f4eb2.svg";